import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const initialState = { isLoading: false, data: {}, errors: [], myVideos: [], myVideosLoading: false };

export const getVideos = createAsyncThunk('videos/getVideos', async (args, thunkApi) => {
  try {
    const { page = 1, size = 10, query = '', filter = JSON.stringify({}) } = args || {};
    const { data } = await axios.get(
      `/api/get_videos?page=${page}&size=${size}&query=${query}&filter=${filter}`
    );
    return thunkApi.fulfillWithValue(data);
  } catch (errors) {
    return thunkApi.rejectWithValue(
      errors.response?.status !== 400 ? { errors: [{ msg: 'something went wrong' }] } : errors.response.data
    );
  }
});

export const createVideo = createAsyncThunk('videos/createVideo', async (args, thunkApi) => {
  try {
    const { data } = await axios.post('/api/create_video', args, {
      headers: { Authorization: thunkApi.getState().auth.token }
    });
    return thunkApi.fulfillWithValue(data);
  } catch (errors) {
    return thunkApi.rejectWithValue(
      errors.response?.status !== 400 ? { errors: [{ msg: 'something went wrong' }] } : errors.response.data
    );
  }
});

export const updateVideo = createAsyncThunk('videos/updateVideo', async (args, thunkApi) => {
  try {
    const id = args.get ? args.get('_id') : args._id;
    const { data } = await axios.put(`/api/update_video/${id}`, args, {
      headers: { Authorization: thunkApi.getState().auth.token }
    });
    return thunkApi.fulfillWithValue(data);
  } catch (errors) {
    return thunkApi.rejectWithValue(
      errors.response?.status !== 400 ? { errors: [{ msg: 'something went wrong' }] } : errors.response.data
    );
  }
});

export const deleteVideo = createAsyncThunk('videos/deleteVideo', async (args, thunkApi) => {
  try {
    const { data } = await axios.delete(`/api/delete_video/${args._id}`, {
      headers: { Authorization: thunkApi.getState().auth.token }
    });
    return thunkApi.fulfillWithValue(data);
  } catch (errors) {
    return thunkApi.rejectWithValue(
      errors.response?.status !== 400 ? { errors: [{ msg: 'something went wrong' }] } : errors.response.data
    );
  }
});

export const approveVideo = createAsyncThunk('videos/approveVideo', async (args, thunkApi) => {
  try {
    const { data } = await axios.put(`/api/approve_video/${args._id}`, {}, {
      headers: { Authorization: thunkApi.getState().auth.token }
    });
    return thunkApi.fulfillWithValue(data);
  } catch (errors) {
    return thunkApi.rejectWithValue(
      errors.response?.status !== 400 ? { errors: [{ msg: 'something went wrong' }] } : errors.response.data
    );
  }
});

export const getMyVideos = createAsyncThunk('videos/getMyVideos', async (_, thunkApi) => {
  try {
    const { data } = await axios.get('/api/get_my_videos', {
      headers: { Authorization: thunkApi.getState().auth.token }
    });
    return thunkApi.fulfillWithValue(data);
  } catch (errors) {
    return thunkApi.rejectWithValue(
      errors.response?.status !== 400 ? { errors: [{ msg: 'something went wrong' }] } : errors.response.data
    );
  }
});

const videosSlice = createSlice({
  name: 'videos',
  initialState,
  extraReducers: {
    [getVideos.pending]: (state) => { state.isLoading = true; state.errors = []; },
    [getVideos.fulfilled]: (state, action) => { state.isLoading = false; state.data = action.payload; },
    [getVideos.rejected]: (state, action) => { state.isLoading = false; state.data = {}; state.errors = action.payload.errors; },

    [createVideo.pending]: (state) => { state.isLoading = true; state.errors = []; },
    [createVideo.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.data.itemsCount = (state.data.itemsCount || 0) + 1;
      if ((state.data.data?.length || 0) < 10) state.data.data = [...(state.data.data || []), action.payload.data];
    },
    [createVideo.rejected]: (state, action) => { state.isLoading = false; state.errors = action.payload.errors; },

    [updateVideo.pending]: (state) => { state.isLoading = true; state.errors = []; },
    [updateVideo.fulfilled]: (state, action) => {
      state.isLoading = false;
      const idx = state.data.data?.findIndex(el => el._id === action.payload.data._id);
      if (idx !== undefined && idx >= 0) state.data.data[idx] = action.payload.data;
    },
    [updateVideo.rejected]: (state, action) => { state.isLoading = false; state.errors = action.payload.errors; },

    [deleteVideo.pending]: (state) => { state.isLoading = true; state.errors = []; },
    [deleteVideo.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.data.data = state.data.data?.filter(el => el._id !== action.payload.data._id);
      state.data.itemsCount = Math.max(0, (state.data.itemsCount || 1) - 1);
    },
    [deleteVideo.rejected]: (state, action) => { state.isLoading = false; state.errors = action.payload.errors; },

    [approveVideo.pending]: (state) => { state.isLoading = true; state.errors = []; },
    [approveVideo.fulfilled]: (state, action) => {
      state.isLoading = false;
      const idx = state.data.data?.findIndex(el => el._id === action.payload.data._id);
      if (idx !== undefined && idx >= 0) state.data.data[idx] = action.payload.data;
    },
    [approveVideo.rejected]: (state, action) => { state.isLoading = false; state.errors = action.payload.errors; },

    [getMyVideos.pending]: (state) => { state.myVideosLoading = true; state.myVideos = []; },
    [getMyVideos.fulfilled]: (state, action) => { state.myVideosLoading = false; state.myVideos = action.payload.data; },
    [getMyVideos.rejected]: (state) => { state.myVideosLoading = false; },
  }
});

export default videosSlice.reducer;
